import { z } from 'zod';

/**
 * Cursor-based пагинация. Контракт зафиксирован в `docs/architecture/api-contracts.md` §1.
 * Курсор — opaque base64; клиент НЕ парсит, только передаёт обратно в `?cursor=`.
 */
export const PaginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export type PaginationQuery = z.infer<typeof PaginationQuerySchema>;

/**
 * Унифицированная обёртка списка. `nextCursor=null` — последняя страница.
 */
export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    nextCursor: z.string().nullable(),
  });
